var ConfigHelper = require("./ConfigHelper").default;

var SSOConfig = {
  getPrefix: function () {
    return ConfigHelper.getURL("host_sso");
  },
};

module.exports = SSOConfig;
